$(function () {
  if (!customElements.get('select-href')) {
    customElements.define(
      'select-href',
      class selectHref extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.init();
        }
        init() {
          let selectDom = this.querySelector('.select_href_main');
          selectDom.addEventListener('click', (event) => {
            this.compareDropdownTrigger(event);
          });
          document.addEventListener('click', (e) => {
            this.cleanAllDropdownSelect(e);
          });
        }
        compareDropdownTrigger(event) {
          event.stopPropagation();
          let selectDom = this.querySelector('.select_href_main');
          let visibleValue = selectDom.getAttribute('data-visible');
          // 如果当前值是 'false'，则修改为 'true'，否则修改为 'false'
          let newVisibleValue = visibleValue === 'false' ? 'true' : 'false';
          selectDom.setAttribute('data-visible', newVisibleValue);
        }
        cleanAllDropdownSelect(e) {
          let className = e.target.className;
          if (className === 'select_href_options') {
            return;
          }
          let selectDom = this.querySelector('.select_href_main');
          if (selectDom.getAttribute('data-visible') === 'true') {
            selectDom.setAttribute('data-visible', 'false');
          }
        }
      }
    );
  }
});
